import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { SubmitTestRunDialog } from '../../../../../../../../features/o5/e2e/submit-test-run-dialog';
import { TestRunsTable } from '../../../../../../../../features/o5/e2e/test-runs-table';
import { getPageHead } from '../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/test-run/_test-run/$environment/')({
  head: () => getPageHead('E2E Test Runs'),
  component: EnvironmentE2ETestRunList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const { environment } = Route.useParams();

  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
        <RequiresAccess write>
          <SubmitTestRunDialog
            environment={environment}
            trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="Submit Test Run" size="small" />}
          />
        </RequiresAccess>
        {filter}
      </HorizontalStack>
    </HorizontalStack>
  );
}

function EnvironmentE2ETestRunList() {
  const { environment } = Route.useParams();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <TestRunsTable environment={environment} HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
